<template>
<div id="helpModal" class="configurator-modal" name="helpModal">
  <div class="configurator-modal-inner">
    <div class="modal-head">
        <i @click="setHelpInvisible()" class="configurator-modal-close-button fal fa-times"></i>
        <h2 class="configurator-modal-headline">
            Hilfe zum Konfigurator    
        </h2>
    </div>
    <div class="configurator-modal-content-wrapper">
        <div class="configurator-modal-content-column">
            <h4>Kontaktmöglichkeiten</h4>
            <div class="configurator-modal-content-column-paragraph">
                <div v-html="p_helpSettings[0].value"></div>
                <div class="configurator-icon-with-text-wrapper">
                    <div v-if="p_helpSettings[1].value != ''" class="configurator-icon-with-text">
                        <a v-bind:title="p_helpSettings[1].value" v-bind:href="p_helpSettings[2].value" class="brand-color-text">
                            <i class="fal fa-phone fa-fw"></i> 
                            <br> Telefon 
                        </a> 
                    </div> 
                    <div v-if="p_helpSettings[3].value != ''" class="configurator-icon-with-text"> 
                        <a v-bind:title="p_helpSettings[3].value" v-bind:href="p_helpSettings[4].value" class="brand-color-text"> 
                            <i class="fal fa-envelope fa-fw"></i> <br> E-Mail 
                        </a> 
                    </div> 
                </div>
            </div>
        </div>
        <div class="configurator-modal-content-column">
            <h4>Interaktionsmöglichkeiten</h4>
            <div class="modal-desktop-wrapper">
                <div class="configurator-modal-content-column-paragraph">
                    <i class="fal fa-info-circle"></i>
                    Mit gefärbten Elementen können Sie
                    <div class="configurator-hover-icon stepform-hover-element" >
                        <span class="configurator-hover-icon-label" @mouseover="isInformationVisible = true" @mouseout="isInformationVisible = false"> interagieren </span>
                        <span class="configurator-tooltip brand-color" v-bind:style="{ display:isInformationVisible ? 'block' : 'none' }">
                            <h4 class="configurator-tooltip-header">
                                <i class="fal fa-info-circle"></i> Info 
                            </h4>
                            <span class="configurator-tooltip-body">Falls dies Ihre Frage nicht klärt stehen wir auch telefonisch für Sie bereit.</span>
                        </span> 
                        um weitere Informationen anzuzeigen 
                    </div>
                    <p> Klicken Sie auf das Bild in einer Karte, um es vergrößert anzuzeigen. <img src="@/assets/common/help/vergroesserungsansicht.png" alt="Klicken Sie auf die Bilder in den Karten, um unsere Fotos zu vergrößern" class="configurator-modal-content-column-paragraph-image"> 
                    </p> 
                </div> 
            </div> 
            <h4>Optimale Nutzererfahrung</h4> 
            <div class="configurator-modal-content-column-paragraph"> 
                <p> Für eine optimale Nutzererfahrung empfehlen wir Ihnen einen aktuellen Browser wie Microsoft Edge, Apple Safari, Google Chrome oder Mozilla Firefox zu benutzen. Die Nutzungserfahrung in älteren Browsern kann abweichen. Für die optimale Nutzungserfahrung sollten Sie den Konfigurator außerdem auf einem Gerät mit einer Auflösung von mindestens 1200 x 800 Pixeln nutzen. 
                </p> 
            </div> 
        </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    props: {
        p_helpSettings: [],
    },
    data() {
        return {
            isInformationVisible: false,
        };
    },
    methods: {
        setHelpInvisible() {
            this.$parent.setHelpVisibility(false);
        },
    },
    
};
</script>


<style language="css">
  @import '../../scss/help/style.css';
</style>


// WEBPACK FOOTER //
// src/components/configurator/Help.vue